import React, { useEffect, useRef, useState } from "react";

interface MonthYearDropdownProps {
  onChange: (payload: { month: string; year: string }) => void;
}

const months = [
  { label: "Jan", value: "01" },
  { label: "Feb", value: "02" },
  { label: "Mar", value: "03" },
  { label: "Apr", value: "04" },
  { label: "May", value: "05" },
  { label: "Jun", value: "06" },
  { label: "Jul", value: "07" },
  { label: "Aug", value: "08" },
  { label: "Sep", value: "09" },
  { label: "Oct", value: "10" },
  { label: "Nov", value: "11" },
  { label: "Dec", value: "12" },
];

const MonthYearDropdown: React.FC<MonthYearDropdownProps> = ({ onChange }) => {
  const currentYear = new Date().getFullYear();
  const [selectedMonth, setSelectedMonth] = useState<string>("");
  const [selectedYear, setSelectedYear] = useState<string>("");

  const [showMonth, setShowMonth] = useState(false);
  const [showYear, setShowYear] = useState(false);
  const [decadeStart, setDecadeStart] = useState(
    currentYear - (currentYear % 10)
  );

  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target as Node)
      ) {
        setShowMonth(false);
        setShowYear(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const handleMonthToggle = () => {
    setShowMonth(!showMonth);
    setShowYear(false);
  };

  const handleYearToggle = () => {
    setShowYear(!showYear);
    setShowMonth(false);
  };

  const handleMonthSelect = (value: string) => {
    setSelectedMonth(value);
    setShowMonth(false);
    onChange({ month: value, year: selectedYear });
  };

  const handleYearSelect = (value: string) => {
    setSelectedYear(value);
    setShowYear(false);
    onChange({ month: selectedMonth, year: value });
  };

  const getYearsInDecade = (start: number) =>
    Array.from({ length: 10 }, (_, i) => (start + i).toString());

  return (
    <div className="month-year-wrapper" ref={wrapperRef}>
      {/* Month Picker */}
      <div className="picker-container">
        <div className="picker-box" onClick={handleMonthToggle}>
          <i className="ti ti-calendar-stats" style={{ marginRight: 6 }} />
          {selectedMonth
            ? months.find((m) => m.value === selectedMonth)?.label
            : "Month"}
        </div>
        {showMonth && (
          <div className="dropdown-card">
            <div className="dropdown-grid">
              {months.map((month) => (
                <div
                  key={month.value}
                  className={`grid-item ${
                    selectedMonth === month.value ? "selected" : ""
                  }`}
                  onClick={() => handleMonthSelect(month.value)}
                >
                  {month.label}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Year Picker */}
      <div className="picker-container">
        <div className="picker-box" onClick={handleYearToggle}>
          <i className="ti ti-calendar-stats" style={{ marginRight: 6 }} />
          {selectedYear || "Year"}
        </div>
        {showYear && (
          <div className="dropdown-card">
            <div className="decade-header">
              <button
                className="icon-button"
                onClick={() => setDecadeStart(decadeStart - 10)}
              >
                <i className="ti ti-chevron-down" />
              </button>
              <span>{`${decadeStart} - ${decadeStart + 9}`}</span>
              <button
                className="icon-button"
                onClick={() => setDecadeStart(decadeStart + 10)}
              >
                <i className="ti ti-chevron-up" />
              </button>
            </div>
            <div className="dropdown-grid">
              {getYearsInDecade(decadeStart).map((year) => (
                <div
                  key={year}
                  className={`grid-item ${
                    selectedYear === year ? "selected" : ""
                  }`}
                  onClick={() => handleYearSelect(year)}
                >
                  {year}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MonthYearDropdown;
